import { Component } from '@angular/core';
import { Router } from "@angular/router";
import { InputTextModule } from "primeng/inputtext";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { NotificationService } from "@core/services/notification/notification.service";
import { PasswortResetApiService, PasswortResetVO } from "@core/api/v1";

@Component({
  selector: 'app-passwort-vergessen',
  standalone: true,
    imports: [
        InputTextModule,
        ReactiveFormsModule
    ],
  templateUrl: './passwort-vergessen.component.html',
  styleUrl: './passwort-vergessen.component.scss'
})
export class PasswortVergessenComponent {
    formular = this.formbuilder.group({
        emailAdresse: ['', [ Validators.required, Validators.email ]],
    });

    constructor(private formbuilder: FormBuilder,
                private passwortResetService: PasswortResetApiService,
                private notificationService: NotificationService,
                private router: Router) {
    }

    erzeugePasswortReset() {
        const request: PasswortResetVO = {
            emailAdresse: this.formular.getRawValue().emailAdresse!
        };
        this.passwortResetService.forderePasswortReset(request).subscribe({
            next: response => {
                this.notificationService.showSuccess('Wenn diese Email-Adresse bei uns registriert ist, senden wir Ihnen eine Mail mit weiteren Instruktionen');
                this.router.navigate(["/"]);
            },
            error: error => {
                console.log(error);
                this.notificationService.showError(error.message);
            }
        });
    }
}
